const e = (t) => ({
  ...t,
  withCredentials: !0,
  timeout: 6e4,
  maxBodyLength: 104857600,
  maxContentLength: 104857600,
  throwOnError: !0,
  parseAs: "json"
  // We do not always have the content type header in each request so we parse as json by default
});
export {
  e as createClientConfig
};
